const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';
const AUTH_EXPIRED = 'AUTH_EXPIRED';
const CLEAR_AUTH_REDIRECT = 'CLEAR_AUTH_REDIRECT';
const FORGOT_PASSWORD_LOADING = 'FORGOT_PASSWORD_LOADING';
const RESET_PASSWORD_LOADING = 'RESET_PASSWORD_LOADING';
const CHANGE_PASSWORD_LOADING = 'CHANGE_PASSWORD_LOADING';

export const TYPES_AUTH = {
  LOGIN,
  LOGOUT,
  AUTH_EXPIRED,
  CLEAR_AUTH_REDIRECT,
  FORGOT_PASSWORD_LOADING,
  RESET_PASSWORD_LOADING,
  CHANGE_PASSWORD_LOADING,
};
